/**
 * Ranh giới BẤT ĐỒNG BỘ của Module Federation.
 *
 * Host chia sẻ react / react-dom / @apollo/client xuống remote (CON-29). Runtime của MF phải
 * dựng xong bảng chia sẻ TRƯỚC khi bất cứ module nào import react — nếu entry import thẳng
 * thì nó gọi `loadShareSync` lúc bảng chưa sẵn sàng và app chết trắng màn hình
 * (RUNTIME-006). Một dynamic import là đủ để tách hai việc đó ra.
 */
import { captureInstallPrompt } from './features/pwa/install-prompt';
import { recoverFromStaleBundle } from './stale-bundle';

// Trước `import('./bootstrap')`: trình duyệt bắn lời mời cài đúng một lần mỗi lượt mở trang.
captureInstallPrompt();

const storage = (() => { try { return globalThis.sessionStorage; } catch { return null; } })();

import('./bootstrap').catch((err: unknown) =>
  recoverFromStaleBundle(err, {
    storage,
    refetchHtml: () => fetch(globalThis.location.href, { cache: 'reload' }),
    reload: () => globalThis.location.reload(),
    showError: (message) => {
      const box = document.querySelector('#root .nap-nguoi');
      if (!box) return;
      box.setAttribute('role', 'alert');
      box.innerHTML = '';
      const p = document.createElement('p');
      p.textContent = message;
      box.appendChild(p);
    },
  }),
);
